module.exports = __webpack_public_path__ + "static/media/RF032.3b0f447b.webp";